import React from "react";
import "../../../resources/styles/auth.scss";
import { useNavigate, useParams } from "react-router-dom";
import { api } from "../../../controllers/api";
function ResetPassword() {
  const token = useParams().token;
  const navigate = useNavigate();
  const [loading, setLoading] = React.useState(false);
  const [isMatch, setIsMatch] = React.useState(false);
  const [password, setPassword] = React.useState("");
  const [confirmPassword, setConfirmPassword] = React.useState("");
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (confirmPassword.trim() !== password.trim()) {
      setIsMatch(true);
      return;
    }
    try {
      setLoading(true);
      let req = await fetch(api + "/reset-customer-password?token=" + token, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ password }),
      });
      if (req.ok) {
        navigate("/auth/login");
        setPassword("");
        setConfirmPassword("");
        setIsMatch(false);
      } else {
        alert("Failed to reset password. Please try again.");
      }
    } catch (error) {
      console.error("Error resetting password:", error);
    } finally {
      setLoading(false);
    }
  };
  return (
    <div className="reset-password-con">
      <form onSubmit={handleSubmit} className="reset-password-con__form">
        <h2>Reset Password</h2>
        <p>Please enter your new password</p>

        <div className="input-con">
          <input
            type="password"
            name="password"
            value={password}
            autoComplete="new-password"
            onFocus={() => {
              setIsMatch(false);
            }}
            onChange={(text) => {
              setPassword(text.target.value);
            }}
            placeholder="New Password"
            required
          />
          <input
            type="password"
            value={confirmPassword}
            onFocus={() => {
              setIsMatch(false);
            }}
            onChange={(text) => {
              setConfirmPassword(text.target.value);
            }}
            placeholder="Confirm Password"
            required
          />
          {isMatch && <small>Passwords do not match</small>}
          <button disabled={loading} type="submit">
            Reset Password
          </button>
        </div>
      </form>
    </div>
  );
}

export default ResetPassword;
